import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Button,
} from "@mui/material";
import CameraAltRoundedIcon from "@mui/icons-material/CameraAltRounded";
import ImageIcon from "@mui/icons-material/Image";

// ─── ImageSourceDialog ────────────────────────────────────────────────────────
const ImageSourceDialog = ({
  open,
  index,
  prefix = "",
  onClose,
  onTakePhoto,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { borderRadius: 3, width: "100%", maxWidth: 320, mx: "auto" },
    }}
  >
    <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
      Choose Image Source
    </DialogTitle>
    <DialogContent sx={{ pb: 2 }}>
      <Stack spacing={1.5}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<CameraAltRoundedIcon />}
          onClick={() => {
            onClose();
            // Live camera (webcam on desktop, device camera on mobile).
            onTakePhoto?.();
          }}
          sx={{ py: 1.5, borderRadius: 2 }}
        >
          Take Photo (Camera)
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<ImageIcon />}
          onClick={() => {
            const el = document.getElementById(
              `${prefix}gallery-input-${index}`,
            );
            if (el) el.click();
            onClose();
          }}
          sx={{ py: 1.5, borderRadius: 2 }}
        >
          Choose from Gallery
        </Button>
      </Stack>
    </DialogContent>
  </Dialog>
);

export default ImageSourceDialog;
